import { reduxActions, apiRoutes, requestStatus, standardHeaders, contentTypes, appConstants, fetchTypes } from '../constants';
import { http, AuthDelegate, ResourceMap } from '../utils';
import { ResourceActions } from '../actions';

export default class AuthActions {

    static loginStart() {
        return {
            type: reduxActions.LOGIN_START,
            progress: requestStatus.BUSY,
            message: ''
        }
    }

    static loginSuccess() {
        return {
            type: reduxActions.LOGIN_SUCCEEDED,
            progress: requestStatus.ACTIVE,
            message: 'User is successfully authenticated'
        }
    }

    static loginFailed(message) {
        return {
            type: reduxActions.LOGIN_FAILED,
            progress: requestStatus.ERROR,
            message: message
        }
    }

    static setCurrentUser(user) {
        AuthDelegate.saveUser(user);
        ResourceMap.setAuthToken(user['access_token']);

        return dispatch => {
            dispatch(AuthActions.setSession(user));
            dispatch(AuthActions.scheduleTokenRefresh(user));
        }
    }

    static updateApprovalStatus(status) {
        return {
            type: reduxActions.UPDATE_USER_APPROVAL_STATUS,
            status: status
        }
    }

    static setSession(user) {
        return {
            type: reduxActions.SET_SESSION,
            user: user
        }
    }

    static authenticate(credentials) {
        // credentials['client_id'] = appConstants.CLIENTID;
        credentials['grant_type'] = 'password';
        credentials['client_id'] = appConstants.CLIENTID;
        return dispatch => {
            let headers = {};
            headers[standardHeaders.CONTENT_TYPE] = contentTypes.FORM_DATA;

            dispatch(AuthActions.loginStart());
            http.post(apiRoutes.TOKEN, credentials, {
                headers: headers
            })
            .success(user => {
                dispatch(AuthActions.setCurrentUser(user));
                dispatch(AuthActions.loginSuccess());
            })
            .error(err => {
                dispatch(AuthActions.loginFailed(err));
            })
        }
    }

    static logOut() {
        AuthDelegate.clearLocalStorage();
        return dispatch => {
            dispatch(AuthActions.endSession());
        }
    }

    static endSession() {
        return {
            type: reduxActions.END_SESSION
        }
    }

    static refreshToken(user) {
        const token = user['refresh_token'];
        if (typeof token !== 'string') {
            return dispatch => {
                dispatch(AuthActions.logOut(user));
            }
        }

        let info = {
            'client_id': appConstants.CLIENTID,
            'grant_type': 'refresh_token',
            'refresh_token': token
        }

        return dispatch => {
            dispatch(ResourceActions.resourceFetch(fetchTypes.TOKEN, info));
        }
    }

    static authenticateWithRefreshToken(token) {
        return dispatch => {
            let headers = {
                [standardHeaders.CONTENT_TYPE]: contentTypes.FORM_DATA
            }

            dispatch(AuthActions.loginStart());
            http.post(apiRoutes.TOKEN, {
                'client_id': appConstants.CLIENTID,
                'grant_type': 'refresh_token',
                'refresh_token': token
            }, {
                headers: headers
            })
            .success(user => {
                dispatch(AuthActions.setCurrentUser(user));
                dispatch(AuthActions.loginSuccess());
            })
            .error(err => {
                dispatch(AuthActions.loginFailed(err));
            })
        }
    }

    static scheduleTokenRefresh(user) {
        return dispatch => {
            dispatch(AuthActions.destroyTokenRefresher(user.tokenRefresher));

            let interval = user['expires_in'] - 300;
            let timeout = setTimeout(() => {
                dispatch(AuthActions.refreshToken(user['refresh_token']))
            }, interval * 1000);

            dispatch(AuthActions.setTokenRefresher(timeout));
        }
    }

    static setTokenRefresher(id) {
        return {
            type: reduxActions.SCHEDULE_TOKEN_REFRESH,
            refresher: id
        }
    }

    static destroyTokenRefresher(id) {
        clearTimeout(id);

        return {
            type: reduxActions.CANCEL_TOKEN_REFRESH
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/auth-actions.js